import { useQuery } from "react-query";
import { axiosInstance } from "../../axios/axiosInstance";

export default function useUnreadMessageCount(enabled = true) {
  const fetchUnreadCount = async () => {
    const { data } = await axiosInstance.get("/api/Conversation/unread-count");
    return data as number;
  };

  return useQuery("UnreadMessageCount", fetchUnreadCount, {
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
    refetchInterval: 60000,
  });
}
